import { render, staticRenderFns } from "./GroupsFilter.vue?vue&type=template&id=3d1905a8&scoped=true"
import script from "./GroupsFilter.vue?vue&type=script&lang=js"
export * from "./GroupsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1905a8",
  null
  
)

export default component.exports